import React, {Component} from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import About from '../../components/Sections/About';
import SpotifyPlayerLarge from '../../components/Media/SpotifyPlayerLarge';
import SpotifyPlayerSmall from '../../components/Media/SpotifyPlayerSmall';
import PhotoGallery from '../../components/Sections/PhotoGallery';
import PressList from '../../components/Sections/PressList';
import VideoGallery from '../../components/Sections/VideoGallery';
import Hero from '../../components/Hero';

function mapStateToProps(state) {
   return {
  };
}

function mapDispatchToProps(dispatch) {
  return {
  }
}

class PressKit extends Component {

  render() {
    // const { } = this.props;

    return (
      <div className="PressKit">
        <Hero />
        <h2>Biography</h2>
        <div className="press__section press__bio">
          <About />
        </div>
        
        <div className="press__section press__contact">
          <h2>Contact Info</h2>
          <div className="item__callout">
            <h4>Press and booking inquiries</h4>
            <p>moose.almighty.music@gmail.com</p>
            <p><Link to="/contact">Or send us a message here</Link></p>
          </div>
        </div>

        <div className="press__section press__press">
          <h2>Press</h2>
          <PressList />
        </div>

        <div className="press__section press__video">
          <h2>Video</h2>

          <VideoGallery />

        </div>


        <div className="press__section press__photography">
          <h2>Photography</h2>
          <p>Click on a photo to view high resolution</p>

          <PhotoGallery />

        </div>

        <div className="press__section press__music">
          <h2>Music</h2>
          <div className="press__music__grid">

            <div className="press__music__grid__item">
              <div className="press__music__player">
                <SpotifyPlayerLarge 
                  url="https://open.spotify.com/embed/album/5rsySS0JA4132kDauWgOk0"
                  height="400"
                />
              </div>
              <p>
              Underwater Hotel
              <br />
              <i>
              Released March 3, 2023
              </i>
              </p>
          

            </div>


            <div className="press__music__grid__item">
              <div className="press__music__player">
                <SpotifyPlayerLarge
                  url="https://open.spotify.com/embed/album/0IjRUhOXzasdSYmOnxSWSP"
                  height="400"
                />
              </div>
              <p>
              Moose Tracks: 7/21/22, Nectar Lounge, Seattle, WA
              <br />
              <i>Released September 23, 2022</i>
              </p>
              <p className="press__music__callout">
                <Link to="https://moosealmighty.bandcamp.com/album/moose-tracks-2022-07-21-nectar-lounge-seattle-wa" target="_blank">Listen on Bandcamp</Link>
              </p>
            </div>


            <div className="press__music__grid__item">
              <div className="press__music__player">
                <SpotifyPlayerLarge 
                  url="https://open.spotify.com/embed/album/4Q0dZ7hjlt9u1CtGtuhP9K"
                  height="400"
                />
              </div>
              <p>
              We Play Shows 
              <br />
              <i>Released October 29, 2021</i>
              </p>
              <p className="press__music__callout">
                <Link to="https://moosealmighty.bandcamp.com/album/we-play-shows" target="_blank">Listen on Bandcamp</Link>
              </p>
            </div>
            

          </div>

          <div className="press__music__grid">


            <div className="press__music__grid__item">
              <div className="press__music__player">
                <SpotifyPlayerLarge
                  url="https://open.spotify.com/embed/album/432fXgHmXnZTLLNr406xUR"
                  height="400"
                />
              </div>
              <p>
              Spare Parts 
              <br />
              <i>Released March 26, 2021</i>
              </p>
              <p className="press__music__callout">
                <Link to="https://moosealmighty.bandcamp.com/album/spare-parts" target="_blank">Listen on Bandcamp</Link>
              </p>
            </div>

            <div className="press__music__grid__item">
              <div className="press__music__player">
                <SpotifyPlayerLarge
                  url="https://open.spotify.com/embed/album/1KjUyIXBTwWHJ5gFeEMRLS"
                  height="400"
                />
              </div>
              <p>
              The Lugagge Underneath 
              <br />
              <i>Released August 7, 2020</i>
              </p>
              <p className="press__music__callout">
                <Link to="https://moosealmighty.bandcamp.com/album/the-luggage-underneath" target="_blank">Listen on Bandcamp</Link>
              </p>
            </div>

            <div className="press__music__grid__item">
              <div className="press__music__player">
                <SpotifyPlayerLarge
                  url="https://open.spotify.com/embed/album/7KFf0FEtLaqyLDWBIbuPip"
                  height="400"
                />
              </div>
              <p>
              Bound & Revolving 
              <br />
              <i>Released April 11, 2019</i>
              </p>
              <p className="press__music__callout">
                <Link to="https://moosealmighty.bandcamp.com/album/the-luggage-underneath" target="_blank">Listen on Bandcamp</Link>
              </p>
            </div>

          </div>
        </div>



        <div className="press__section press__media">
          <h2>Social Media</h2>
          <div className="item__callout">
            <h4>Instagram</h4>
            https://instagram.com/moosealmightyband
          </div>
          <div className="item__callout">
            <h4>Facebook</h4>
            https://www.facebook.com/moosealmightymusic
          </div>
          <div className="item__callout">
            <h4>Youtube</h4>
            https://www.youtube.com/channel/UCswARUsQRIkZi2vD5YUg6ww
          </div>
        </div>

      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PressKit);







// WEBPACK FOOTER //
// ./src/views/PressKit/PressKit.js